import React from 'react'
import marked from 'marked'
import { RouteComponentProps, withRouter } from 'react-router'
import ContentfulCardCarousel from './ContentfulCardCarousel'
import { SupportedDestinations } from 'home/constants'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ContentfulOfferCarousel from './ContentfulOfferCarousel'
import LayoutContainer from 'components/Common/LayoutContainer'
import ValuePropositionBanner from 'home/components/ValuePropositionBanner/ValuePropositionBanner'
import ContentfulExperienceOfferCarousel from './ContentfulExperienceOfferCarousel'
import SupportTile from 'components/Common/SupportTile/SupportTile'
import TourUSPContainer from 'components/OfferPage/TourV2/TourUSPContainer'
import SearchHero from './SearchHero'
import ContentfulHeroOfferCarouselSection from './ContentfulHeroOfferCarouselSection'
import AdditionalGuides from 'components/Pages/LandingPage/Hub/AdditionalGuides/AdditionalGuides'

type Props = RouteComponentProps<{ destination: SupportedDestinations}> & App.ContentfulWebPageComponent

marked.setOptions({
  gfm: true,
  tables: true,
  sanitize: true,
  breaks: false,
  pedantic: false,
  smartLists: true,
  smartypants: false,
})

const renderer = new marked.Renderer()

function ContentfulWebPageComponent(props: Props) {
  const title = marked(props.title, { renderer })
  switch (props.contentTypeId) {
    case 'componentHeroCarousel':
      return <>
        <SearchHero heroImage={props.image} heroImageSubtitle={props.subtitle} heroImageTitle={props.title}/>
        <ContentfulHeroOfferCarouselSection destination={props.destination} maxCarouselItemCount={props.maxCarouselItemCount} />
      </>
    case 'componentCardCarousel':
      return <ContentfulCardCarousel
      title={title}
      subtitle={props.subtitle}
      cardItems={props.cardItems}
      viewAllLink={props.viewAllLink}
      isLargeContentWrapper={props.isLargeContentWrapper}/>
    case 'componentExperienceOfferListCarousel':
      return <div>
        <ContentfulExperienceOfferCarousel title={title} destination={props.destination}/>
      </div>
    case 'componentOfferListCarousel':
      return <div><ContentfulOfferCarousel {...props} title={title} />
      </div>
    case 'componentSupport':
      return <LayoutContainer>
        <SupportTile />
      </LayoutContainer>
    case 'componentValuePropositionBanner':
      switch (props.type) {
        case 'tour':
          return <LayoutContainer>
            <TourUSPContainer />
          </LayoutContainer>
        default:
          return <ValuePropositionBanner />
      }
    case 'componentTileNavigation':
      return <AdditionalGuides
          {...props}
      />
    default:
      return <BodyText variant="medium">Unknown component</BodyText>
  }
}

export default withRouter(ContentfulWebPageComponent)
